const translation = passwordlessLoginTranslations

function addRegisterContainer() {
	const shopifyRoot = Shopify.routes.root;
	const rc_login_section = document.querySelector('.rc-login')
	if (!rc_login_section) return
	const registerContainer = document.createElement("div");
	registerContainer.className = "sectionFooter";

	const loginPElement = document.createElement("p");
	loginPElement.innerHTML = translation.loginCopy;

	const loginAnchorElement = document.createElement("a");
	loginAnchorElement.className = "register__link";
	loginAnchorElement.href = `${shopifyRoot}account/login?use_password=true`;


	const loginSpanElement = document.createElement("span");
	loginSpanElement.className = "t-link t-h5";
	loginSpanElement.innerHTML = translation.loginLinkText;

	const dividingSpanElement = document.createElement("span");
	dividingSpanElement.className = "divider";


	const createPElement = document.createElement("p");
	createPElement.innerHTML = translation.createCopy;

	const createAnchorElement = document.createElement("a");
	createAnchorElement.className = "register__link";
	createAnchorElement.href = `${shopifyRoot}account/register`;


	const createSpanElement = document.createElement("span");
	createSpanElement.className = "t-link t-h5";
	createSpanElement.innerHTML = translation.createLinkText;

	loginAnchorElement.appendChild(loginSpanElement);
	registerContainer.appendChild(loginPElement);
	registerContainer.appendChild(loginAnchorElement);

	registerContainer.appendChild(dividingSpanElement);

	createAnchorElement.appendChild(createSpanElement);
	registerContainer.appendChild(createPElement);
	registerContainer.appendChild(createAnchorElement);

	rc_login_section.appendChild(registerContainer)
}

addRegisterContainer()
